import { render } from "./Airlines.vue?vue&type=template&id=a19264a8&scoped=true"
import script from "./Airlines.vue?vue&type=script&lang=js"
export * from "./Airlines.vue?vue&type=script&lang=js"

import "./Airlines.vue?vue&type=style&index=0&id=a19264a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a19264a8"]])

export default __exports__